import v from 'vudu';
import { generate } from 'cooltilities';
import breakpoints from './breakpoints';
import colors from './colors';
import copy from './copy';
import theme from './theme';

const styles = {
  ...generate(colors),
  ...copy,
  ...theme,
};
const classes = v(styles);

export { breakpoints, classes, colors, copy, styles };
